export const ErrorType_LoginBlocked = 'BLOCKED_LOGIN';
export const DefaultMaxLoginAttempts = 5;
//# sourceMappingURL=consts.js.map